(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function expand(details, body, icon) {
    details.open = true;
    var target = body.scrollHeight;
    body.style.height = '0px';
    requestAnimationFrame(function () {
      body.style.height = target + 'px';
    });
    if (icon) icon.textContent = '−';
    body.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'height') return;
      body.style.height = 'auto';
      body.removeEventListener('transitionend', handler);
    });
  }

  function collapse(details, body, icon) {
    var current = body.scrollHeight;
    body.style.height = current + 'px';
    requestAnimationFrame(function () {
      body.style.height = '0px';
    });
    if (icon) icon.textContent = '+';
    body.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'height') return;
      details.open = false;
      body.removeEventListener('transitionend', handler);
    });
  }

  // Delegated at the document level (rather than bound per-element) so accordions keep
  // working after the Shopify theme editor replaces section markup on block select/reorder.
  function onAccordionClick(e) {
    var summary = e.target.closest('.pdp-enhanced-accordion__summary');
    if (!summary) return;

    var details = summary.closest('details.pdp-enhanced-accordion');
    var group = summary.closest('.pdp-buybox-accordions, .pdp-faq__list');
    if (!details || !group) return;

    var body = details.querySelector(':scope > .pdp-enhanced-accordion__body');
    if (!body) return;
    var icon = summary.querySelector('.pdp-enhanced-accordion__icon');

    e.preventDefault();

    if (details.open) {
      collapse(details, body, icon);
      return;
    }

    var siblings = group.querySelectorAll(':scope > details.pdp-enhanced-accordion');
    siblings.forEach(function (other) {
      if (other !== details && other.open) {
        collapse(
          other,
          other.querySelector(':scope > .pdp-enhanced-accordion__body'),
          other.querySelector('.pdp-enhanced-accordion__icon')
        );
      }
    });
    expand(details, body, icon);
  }

  function initScrollReveal() {
    // Both the section wrapper (.pdp-reveal) and its stagger grid (.pdp-reveal--stagger) need
    // to be observed independently — they're separate elements and each needs its own
    // "--visible" class added directly to itself for its CSS rule to match.
    var revealEls = document.querySelectorAll('.pdp-reveal:not(.pdp-reveal--visible), .pdp-reveal--stagger:not(.pdp-reveal--visible)');
    if (!revealEls.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('pdp-reveal--visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pdp-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initCountUp() {
    var counters = document.querySelectorAll('.pdp-results-stats__percentage[data-count-to]:not([data-count-bound])');
    if (!counters.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      counters.forEach(function (el) {
        el.setAttribute('data-count-bound', '1');
        var target = el.getAttribute('data-count-to');
        var suffix = el.getAttribute('data-count-suffix') || '';
        el.textContent = target + suffix;
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          animateCount(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(function (el) {
      el.setAttribute('data-count-bound', '1');
      observer.observe(el);
    });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    var suffix = el.getAttribute('data-count-suffix') || '';
    if (isNaN(target)) return;

    el.textContent = '0' + suffix;
    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = target + suffix;
      }
    }
    requestAnimationFrame(step);
  }

  function init() {
    document.addEventListener('click', onAccordionClick);
    initScrollReveal();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The Shopify theme editor re-renders section markup on block select/reorder/setting
  // change, which can inject fresh .pdp-reveal / .pdp-reveal--stagger / counter elements
  // that were never observed. Re-scan (idempotent) whenever that happens.
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initCountUp();
  });
})();
